<template>
    <pop-form class="form-box" :state="state" width="580px" body-max-height="350px">
        <template slot="title">{{title}}</template>
        <div class="body-box">
            <div class="over-box">
                <div class="success-icon"><i class="el-icon-success"></i></div>
                <div class="total-price">¥ {{overData.totalPayMoney}}</div>
                <div class="user-money">账户余额 {{overData.storeUserMoney}}</div>
                <div class="print-box">
                    <el-button plain @click="printEvent">打印小票</el-button>
                </div>
            </div>
        </div>
        <template slot="foot">
            <el-button size="medium" type="primary" @click="settleAllOver">确定</el-button>
        </template>
    </pop-form>
</template>

<script>
    import PopForm from "@/model/PopForm";
    export default {
        name: "CashPayDone",
        components: {PopForm},
        model: {
            prop: "state",
            event: "stateChange"
        },
        props: {
            state: {
                type: Boolean,
                default: false
            },
            overData: {
                type: Object,
                default: () => ({
                    totalPayMoney: "0.00",
                    storeUserMoney: "0.00",
                }),
            }
        },
        data: () => ({
            title: "结算成功",
            // totalPayMoney: "100.00",
            // storeUserMoney: "83.00",
        }),
        methods: {
            settleAllOver: function () {
                this.$emit("stateChange", false);
                this.$emit("settleOver");
            },
            printEvent: function () {
                this.$emit("printEvent", true);
            }
        }
    }
</script>

<style scoped>
    .total-price{
        color: #7ed321;
        font-size: 28px;
        text-align: center;
        padding-top: 10px;
    }
    .success-icon{
        color: #7ed321;
        font-size: 80px;
        text-align: center;
        padding-top: 40px;
    }
    .print-box{
        text-align: center;
        padding-top: 30px;
    }
    .user-money{
        text-align: center;
        padding-top: 10px;
    }
</style>
